import { render, staticRenderFns } from "./ClientTransactions.vue?vue&type=template&id=1a0c6b3f&scoped=true&"
import script from "./ClientTransactions.vue?vue&type=script&lang=js&"
export * from "./ClientTransactions.vue?vue&type=script&lang=js&"
import style0 from "./ClientTransactions.vue?vue&type=style&index=0&id=1a0c6b3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c6b3f",
  null
  
)

export default component.exports